import React from "react";
import FormatDateTime from "../../../../Functions/FormatDate";

const PlayboxLogsMain = ({ podInfo }) => {

    const renderStatus = (status) => {
        if (status === "Failed") {
            return <span className="title_status failed_cluster"><i className="fa-solid fa-x"></i> Deleted</span>;
        } else if (status === "Running" || status === "active" || status == "Succeeded") {
            return <span className="title_status running_cluster"><i className="fa-solid fa-check"></i> Running</span>;
        } else {
            return <span className="title_status loading_cluster"><i className="fa-solid fa-rotate"></i> Loading</span>;
        }
    };

    return (
        <div className="playbox_logs_main">
            <p className="playbox_logs_main_title">Playbox event logs</p>
            <p className="playbox_logs_main_subtitle">See all the playbox events</p>
            <div className="playbox_logs_cont">
                {podInfo.events.length > 0 ? (
                    // podInfo.events.map((event, index) => (
                    //     <pre key={index} className="log_item_playbox"><i className="fa-solid fa-circle"></i> {event}</pre>
                    // ))
                    <>
                    <pre className="log_item_playbox"><i className="fa-solid fa-circle"></i> Playbox creation {podInfo.status}.</pre>
                    <pre className="log_item_playbox"><i className="fa-solid fa-circle"></i> Playbox {podInfo.name} is running.</pre>
                    </>
                ) : (
                    <>
                        <pre className="log_item_playbox">No logs available</pre>
                    </>
                )}
            </div>
            <div className="playbox_info_cont">
                <p className="start_time">{FormatDateTime(podInfo.start_time)}</p>
                <p className="playbox_log_status">
                      {renderStatus(podInfo.status)}

                </p>
            </div>
        </div>
    );
};

export default PlayboxLogsMain;
